import App from '../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute} from '../../Router'
import Auth from '../../Auth'
import Utils from '../../Utils'
import UserAPI from '../../UserAPI'
import Toast from '../../Toast'
import ProviderAPI from '../../ProviderAPI'

class portfolioView {
  init(){
    document.title = 'Create Profile'    
    this.render()    
    Utils.pageIntroAnim()
    this.updateCurrentUser()
    this.newProviderSubmitHandler()
  }

  async updateCurrentUser(){
    try{
     const updatedUser= await UserAPI.updateUser(Auth.currentUser._id,{newUser:false},'json')
     console.log('user updated')
     console.log(updatedUser)
    }catch(err){
     Toast.show(err,'error')
    }
}

signInSubmitHandler(e){
  e.preventDefault()
  const formData = e.detail.formData
  const submitBtn = document.querySelector('.submit-btn')
  submitBtn.setAttribute('loading', '')    
  
  // sign in using Auth    
  Auth.signIn(formData, () => {
    submitBtn.removeAttribute('loading')
  })
}

 async newProviderSubmitHandler(e){
    e.preventDefault()
    const formData = e.detail.formData
    const submitBtn = document.querySelector('.submit-btn')
    submitBtn.setAttribute('loading', '')  

    
    try{
      await ProviderAPI.newProvider(formData)
      Toast.show('Profile Added')
      submitBtn.removeAttribute('loading')
    
      //reset form
      //reset text + text area iputs
      const textInputs= document.querySelectorAll('sl-input, sl-textarea ')
      if(textInputs) textInputs.forEach(textInput => textInput.value = null)
      //reset radio
      const radioInputs= document.querySelectorAll('sl-radio')
      if(radioInputs) radioInputs.forEach(radioInput => radioInput.removeAttribute('checked'))
      //reset file input
      const fileInput = document.querySelector('input[type=file]')
      if(fileInput) fileInput.value = null
    
    }catch(err){
      Toast.show(err,'error')
      submitBtn.removeAttribute('loading')
    }
    }

    

    
  

  render(){
    const template = html`


    <div class="signuppage">



    <div class="proimagebox">
    
    <div id="signupoverlay" class="animate__animated animate__fadeInLeft">
          <h2  style="font-size:16px; font-weight:700; color: #FFFFFF; "> <span style=" color: #FFA132;">PORTFOLIO</span> SETUP</h2>


          <div class="signupoverlaytxt">
          <h1 class="signtitles" style="color:#FFA132; "  >Just starting out?<br>Struggling to find work?</h1>
          <p class="signtxt"  >Let’s get you set up and we’ll help you find clients at the snap of a finger.</p>
          </div>
          </div>
    
    
    
    
    
    
    
    </div>

    
    <div  class="signup-box">

              <div>
          
                  <h2>Tell us what you do.</h2>
              </div>

          <sl-form class="form-signup" @sl-submit=${this.newProviderSubmitHandler} >


            <div class="container">
                      
              
              
              
              
            
                  <div class="column">


                  <input type="hidden" name="user" value="${Auth.currentUser._id}" />
              <div class="input-group">
                <sl-input Label="Business Name" name="name" type="text" placeholder="Business Name" required></sl-input>
              </div>



                  
                  <div class="input-group-signup" >
                  <sl-select Label="Occupation" name="occupation" style="margin-bottom: .8em;" placeholder="Occupation" >
                      <sl-menu-item name="occupation" value="Garderner">Garderner</sl-menu-item>
                      <sl-menu-item name="occupation" value="Electrician">Electrician</sl-menu-item>
                      <sl-menu-item name="occupation" value="Masonry">Masonry</sl-menu-item>
                      <sl-menu-item name="occupation" value="Painter">Painter</sl-menu-item>
                      <sl-menu-item name="occupation" value="Plumber">Plumber</sl-menu-item>
                      <sl-menu-item name="occupation" value="Air Conditioner"></sl-menu-item>
                      <sl-menu-item name="occupation" value="Wielder">Wielder</sl-menu-item>
                      <sl-menu-item name="occupation" value="Carpenter">Carpenter</sl-menu-item>
                      <sl-menu-item name="occupation" value="PoolCare">Pool Care</sl-menu-item>
                      </sl-select>
               </div>

                    <br>



                    <div class="input-group" style="margin-bottom: 2em;">
                    <label >Experience Level</label><br>
                    <sl-radio-group  label="Select experience level" no-fieldset>
                      <label>-1 yrs</label><sl-radio name="experience" value="1"></sl-radio>
                      <sl-radio name="experience" value="2"></sl-radio>
                      <sl-radio name="experience" value="3"></sl-radio>
                      <sl-radio name="experience" value="4"></sl-radio>
                      <sl-radio name="experience" value="5"></sl-radio><label class="yrs">+5 yrs</label>
                    </sl-radio-group>
                  </div>

                   

                    

                    <div class="input-group-signup" style="margin-bottom: 1.5em;">
                        <sl-textarea Label="Description"name="description" rows="5" placeholder="Description"></sl-textarea>
                    </div>
                  
                  
                  
                  
                  
                  
                  </div>




                  <div class="column">
                  
                  

                  <div class="input-group">              
                  <sl-input Label="Price rate" name="price" type="text" placeholder="Price daily" required>
                    <span slot="prefix">Rs</span>
                  </sl-input>
                </div>

                <div class="input-group" style="margin-bottom: 2em;">
                <label>Image</label><br>
                <input type="file" name="image" />              
            </div>
                  
                  
                  
                  
                  
                  </div>
          
          
          

      
        
            </div> 
      
      <sl-button  name="accessLevel" type="primary" value="2" class="submit-btn" submit style="width: 30%; margin-top: .5em;">CREATE PORTFOLIO</sl-button>

      <sl-button href="/"  name="accessLevel" type="default" value="2" class="submit-btn" submit style="width: 20%; margin-top: .5em; margin-left: 40%;">NEXT</sl-button>


      

    </div>



 </sl-form>
</div>

   





    `
    render(template, App.rootEl)
  }
}


export default new portfolioView()






